import { useRef, useEffect } from 'react';

var noop = function noop() {};

function useHotKey(key, callback, enabled) {
  if (callback === void 0) {
    callback = noop;
  }

  if (enabled === void 0) {
    enabled = true;
  }

  var callbackRef = useRef();
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    if (typeof window === 'undefined') return;
    if (!enabled) return;

    var listener = function listener(event) {
      if (event.target.nodeName === 'INPUT') return;

      if ([key].flat().includes(event.code)) {
        if (callbackRef.current) {
          callbackRef.current();
        }
      }
    };

    document.addEventListener('keydown', listener);
    return function () {
      document.removeEventListener('keydown', listener);
    };
  }, [key, enabled]);
}

export default useHotKey;
//# sourceMappingURL=useHotKey.esm.js.map
